import { Component} from '@angular/core';

import { Events } from './services/events';
import { StorageService } from './services/storage';
import { AlertController, LoadingController, NavController, Platform } from '@ionic/angular';
import { SwUpdate } from '@angular/service-worker';

import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Network } from '@ionic-native/network/ngx';

import { AppVersion } from '@ionic-native/app-version/ngx';

import { Config } from './config/config';
import { UtilitiesService } from 'src/services/utilities.services';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  providers: [Config,AppVersion,SplashScreen,StatusBar,StorageService,Network]
})
export class AppComponent {
  public version_number:string = '';
  public pending_reload:boolean = false;

  constructor(
    public config: Config,
    public events: Events,
    public storage: StorageService,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public utilsSrv: UtilitiesService,
    public platform: Platform,
    public appVersion: AppVersion,
    public splashScreen: SplashScreen,
    public statusBar: StatusBar,
    private swUpdate: SwUpdate,
    private network: Network,
    private http: HttpClient
  ) {

    this.initializeApp();

    this.storage.init();

  }

  async ngOnInit() {
  }

  async initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleLightContent();
      this.splashScreen.hide();

      if (this.swUpdate.isEnabled) {
        this.checkPWAUpdate();
      }

      this.config.connected = navigator.onLine;

      this.loadBaseSettings();

      window.addEventListener('offline', () => {
        this.config.connected = false;
        console.log('disconnected');
      });

      window.addEventListener('online', () => {
        this.config.connected = true;
        console.log('connected');
      });

      if (this.platform.is('cordova') && location.protocol != 'https:') {
        try {
          let notificationOpenedCallback = function(data) {
            this.dialogs.alert(data.notification.payload.body, data.notification.payload.title, 'OK');
            return;
          };

          let notificationReceivedCallback = function(data) {
            return;
          };
        } catch(e) {
        }
      }
    });
  }

  loadBaseSettings() {
    this.utilsSrv.showLoader().then(() => {
      let headers = new HttpHeaders({
        'Business' : this.config.appId,
        'Accept' : 'application/json',
        'Business-Site': (typeof (this.config as any).siteId != 'undefined') ? (this.config as any).siteId : '',
      })

      this.http.get(`${this.config.apiUrl}/settings/custom-background`, { headers : headers })
      .subscribe(async (res:any) => {
        if (res) {
          await this.storage.set('custom_background_image', res.image);
        }
        this.utilsSrv.dismissLoaders();
      }, (err) => {
        this.utilsSrv.dismissLoaders();
      })
    });
  }

  async checkSlug() {
    const slug = await this.storage.get('slug');

    if (location.protocol == 'https:') {
      if (slug != null) {
        if (slug != this.config.appSlug) {
          this.pending_reload = true;

          await this.storage.clear()
          await this.storage.set('slug', this.config.appSlug)

          this.checkAppVersion();
        } else {
          this.pending_reload = false;

          this.checkAppVersion();
        }
      } else {
        this.pending_reload = false;

        await this.storage.set('slug', this.config.appSlug)
        this.checkAppVersion();
      }
    }
  }

  async checkPWAUpdate() {
    this.swUpdate.available.subscribe(async (res) => {
      const update = await this.alertCtrl.create({
        header: '',
        message: 'Nova versão disponível, o aplicativo será atualizado',
        buttons: ['Atualizar']
      });

      await update.present();
      
      update.onDidDismiss()
      .then(async () => {
        this.swUpdate.activateUpdate();

        const loading = await this.loadingCtrl.create({
          message: 'Atualizando...'
        })
      
        await loading.present();
      })
      .then(() => window.location.reload());
    });
    this.swUpdate.checkForUpdate();
  }

  async checkAppVersion() {
    if (this.platform.is('pwa')) {

    } else {
      if (this.platform.is('cordova') && location.protocol != 'https:') {
        this.appVersion.getVersionNumber().then(async (app_version) => {
          let version = await this.storage.get('app_version')
          this.version_number = version;

          if (typeof version == 'string' && version != null) {
            version = version.replace(/\./g, '');
          }

          version = (version) ? parseInt(version) : null;
          app_version = app_version.replace(/\./g, '');

          if (version == null || version < parseInt(app_version)) {
            await this.storage.clear()
            await this.storage.set('app_version', parseInt(app_version))
            window.location.reload();
          } else {
            await this.storage.set('app_version', parseInt(app_version))
            if (this.pending_reload) {
              window.location.reload();
            }
          }
        }, err => {
          console.log('Erro ao verificar versão do app');
          console.log(err);
        })
      } else {
        if (this.pending_reload) {
          window.location.reload();
        }
      }
    }
  }
}
